<template>
  <div id="app-container">
    <div style="text-align: left; width: 100%;">
      <a-button
        @click="goDashboard"
        class="text-left mb-2"
        style="border-radius: 20px; background-image: linear-gradient(to right, #1D2671 , #830051); color: white;"
      >
        <LeftOutlined /> Back
      </a-button>
    </div>
    <div
      style="display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;"
    >
      <h1>Aplikasi QR Code Scanner</h1>
      <p v-if="!program">Arahkan kamera ke QR code untuk memindai.</p>
      <div id="reader"></div>
      <div v-if="program" class="scan-result">
        <div class="doctor-detail-card">
          <h3>{{ program?.patient.fullname }}</h3>
          <p style="color: #999; margin-top: -8px">{{ program?.patient.city }}</p>
        </div>

        <div class="row doctor-detail-grid">
          <div class="col-6 mb-2" v-if="program?.pharmacy"><strong>Apotek</strong><br /></div>
          <div class="col-6 mb-2" v-if="program?.pharmacy">: {{ program?.pharmacy.name }}</div>
          <div class="col-6 mb-2"><strong>Tanggal Pengajuan</strong><br /></div>
          <div class="col-6 mb-2">: {{ formatISODate(program?.enrollDate) }}</div>
          <div class="col-6 mb-2" v-if="program?.carryOverDate">
            <strong>Tanggal Scan</strong><br />
          </div>
          <div class="col-6 mb-2" v-if="program?.carryOverDate">
            : {{ formatISODate(program?.carryOverDate) }}
          </div>
          <div class="col-6 mb-2"><strong>No. KTP</strong><br /></div>
          <div class="col-6 mb-2">: {{ program?.patient.idNumber }}</div>

          <div class="col-6 mb-2"><strong>Form Persetujuan</strong><br /></div>
          <div class="col-6 mb-2">
            <a
              v-if="program?.patient.consent"
              href="#"
              @click.prevent="
                handleDownloadPdf(
                  program.patient.consent,
                  `form-persetujuan-${program.patient.fullname}.pdf`,
                )
              "
            >
              : Download Sekarang
            </a>
            <span v-else>: Tidak tersedia</span>
          </div>
          <div class="col-12 my-2" v-if="program?.patient.consent">
            <iframe
              :src="`${baseUrl}${program.patient.consent}`"
              style="width: 100%; height: 500px; border: 1px solid #e8e8e8; border-radius: 8px"
              title="Form Persetujuan Pasien"
            >
              Browser Anda tidak mendukung pratinjau PDF. Silakan unduh file untuk melihatnya.
            </iframe>
          </div>
          <div class="col-12 mb-2">
            <strong> Foto KTP :</strong>
          </div>

          <div class="col-12 my-2" v-if="program?.patient.idPicture">
            <img
              :src="`${baseUrl}${program?.patient.idPicture}`"
              alt="Foto KTP"
              class="modal-image my-2"
            />
          </div>
          <div class="col-12 my-2">
            <strong> Foto Selfie :</strong>
          </div>

          <div class="col-12 my-2" v-if="program?.patient.selfiePicture">
            <img
              :src="`${baseUrl}${program?.patient.selfiePicture}`"
              alt="Foto Selfie"
              class="modal-image my-2"
            />
          </div>
          <div class="col-6 mb-2"><strong>Email</strong><br /></div>
          <div class="col-6 mb-2">: {{ program?.patient.email }}</div>
          <div class="col-6 mb-2"><strong>Telepon</strong><br /></div>
          <div class="col-6 mb-2">: {{ program?.patient.representativePhone }}</div>
          <div class="col-6 mb-2"><strong>Nama Dokter</strong><br /></div>
          <div class="col-6 mb-2">: {{ program?.doctor.fullname }}</div>
          <div class="col-12 my-2">
            <strong>Hasil Tes :</strong>
          </div>

          <div class="col-12 my-2" v-if="program?.testLab">
            <img
              :src="
                `${baseUrl}${
                  program?.testLab.testLabEvidences[program?.testLab.testLabEvidences.length - 1]
                    .url
                }`
              "
              alt="Hasil Tes"
              class="modal-image my-2"
            />
          </div>
          <div class="col-6 mb-2"><strong>Nama Obat</strong><br /></div>
          <div class="col-6 mb-2">: {{ program?.programType.name }}</div>
          <div class="col-6 mb-2" v-if="program?.price"><strong>Jumlah Obat</strong><br /></div>
          <div class="col-6 mb-2" v-if="program?.price">: {{ program?.price.name }}</div>
          <div class="col-12 my-2">
            <strong>Resep :</strong>
          </div>

          <div class="col-12 my-2" v-if="program?.programEvidences.length">
            <img
              :src="
                `${baseUrl}${program?.programEvidences[program?.programEvidences.length - 1].url}`
              "
              alt="Resep"
              class="modal-image my-2"
            />
          </div>
          <div class="col-12 mb-2" v-if="program?.prevProgram && program?.prevProgram.invoiceUrl">
            <strong> Bukti Pembayaran :</strong>
          </div>

          <div class="col-12 my-2" v-if="program?.prevProgram && program?.prevProgram.invoiceUrl">
            <img
              :src="`${baseUrl}${program?.prevProgram.invoiceUrl}`"
              alt="Bukti Pembayaran"
              class="modal-image my-2"
            />
          </div>
          <div class="col-12 mb-2" v-if="program?.prevProgram && program?.prevProgram.ralanUrl">
            <strong> Bukti Rawat Jalan :</strong>
          </div>

          <div class="col-12 my-2" v-if="program?.prevProgram && program?.prevProgram.ralanUrl">
            <img
              :src="`${baseUrl}${program?.prevProgram.ralanUrl}`"
              alt="Bukti Rawat Jalan"
              class="modal-image my-2"
            />
          </div>
          <div class="col-6 mb-2"><strong>ID Pasien</strong><br /></div>
          <div class="col-6 mb-2">: {{ program?.patient.code }}</div>
          <div class="col-6 mb-2"><strong>Status Permintaan</strong><br /></div>
          <div class="col-6 mb-2">: {{ program?.prevProgram ? 'Perpanjang' : 'Baru' }}</div>
          <div class="col-12">
            <a-button
              type="primary"
              class="w-100"
              size="large"
              @click="submitData"
              :disabled="isSubmitting"
              >{{ isSubmitting ? 'Memproses...' : 'Konfirmasi Pengambilan Obat' }}</a-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { Html5QrcodeScanner } from 'html5-qrcode'
import { getProgramById, updateDrugsTaken } from '../../services/axios/pulih/index'
import { notification } from 'ant-design-vue'
import { useRouter } from 'vue-router'
import { LeftOutlined } from '@ant-design/icons-vue'
// Variabel reaktif untuk menyimpan hasil scan
const isSubmitting = ref(false)

const scanResult = ref(null)
const router = useRouter()
// Variabel untuk menyimpan instance scanner
let html5QrcodeScanner = null
const program = ref()
// Fungsi yang akan dipanggil ketika scan berhasil
const fetchData = async id => {
  const res = await getProgramById(id)
  console.log(res)
  program.value = res
}

const onScanSuccess = (decodedText, decodedResult) => {
  scanResult.value = decodedText
  // Hentikan scanner setelah berhasil untuk menghemat resource
  fetchData(scanResult.value)
  stopScanner()
}

// Fungsi yang akan dipanggil ketika terjadi error
const onScanFailure = error => {
  // Anda bisa menambahkan logika di sini jika perlu,
  // tapi biasanya kita abaikan error "QR code not found".
}

// Fungsi untuk memulai scanner
const startScanner = () => {
  // Pastikan tidak ada hasil scan sebelumnya
  scanResult.value = null

  // Konfigurasi scanner
  const config = {
    fps: 10,
    qrbox: { width: 250, height: 250 },
    rememberLastUsedCamera: true,
  }

  // Buat instance scanner baru
  html5QrcodeScanner = new Html5QrcodeScanner('reader', config, false)

  // Render scanner dengan callback
  html5QrcodeScanner.render(onScanSuccess, onScanFailure)
}

// Fungsi untuk menghentikan scanner dan melepaskan kamera
const stopScanner = () => {
  if (html5QrcodeScanner) {
    html5QrcodeScanner.clear().catch(error => {
      console.error('Gagal membersihkan scanner.', error)
    })
  }
}

// Fungsi untuk tombol "Scan Ulang"
const resetScanner = () => {
  startScanner()
}
const baseUrl = ref('https://pulih-api-prod.digitala.id')

const formatISODate = isoString => {
  if (!isoString) return ''
  const date = new Date(isoString)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${day}-${month}-${year}`
}
const submitData = async () => {
  if (!program.value) return

  isSubmitting.value = true
  try {
    // Menggunakan ID program, bukan patient
    const res = await updateDrugsTaken(program.value.id)
    console.log(res, 'cekii')
    if (res.id) {
      notification.success({
        message: 'Sukses Scan Program',
        description: 'Program sudah berhasil di scan.',
      })
    } else {
      notification.error({
        message: 'Data Program tidak ditemukan',
        description: 'Program tidak berhasil di scan.',
      })
    }
    router.push('/farmasi')
  } catch (error) {
    notification.error({
      message: 'Data Program tidak ditemukan',
      description: 'Program tidak berhasil di scan.',
    })
    program.value = null
    startScanner() // Kembali ke mode scan
  } finally {
    isSubmitting.value = false
  }
}

// Gunakan lifecycle hook `onMounted` untuk memulai scanner saat halaman dimuat.
onMounted(() => {
  startScanner()
})
const goDashboard = () => {
  router.push('/farmasi')
}
// Gunakan lifecycle hook `onUnmounted` untuk membersihkan scanner saat halaman ditutup.
// Ini sangat penting untuk mematikan kamera.
onUnmounted(() => {
  stopScanner()
})
</script>

<style>
/* Styling bisa diletakkan di sini atau di file CSS terpisah */
body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #f4f4f4;
}

#app-container {
  max-width: 500px;
  margin: 40px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
}

#reader {
  width: 100%;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-top: 20px;
}

.scan-result {
  margin-top: 20px;
  padding: 15px;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  word-wrap: break-word; /* Memastikan teks panjang tidak keluar dari kotak */
}

.scan-result h3 {
  margin-top: 0;
}

.scan-result button {
  margin-top: 15px;
  padding: 10px 20px;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.scan-result button:hover {
  background-color: #0056b3;
}

.card-scroll-wrapper {
  overflow-x: auto;
  margin-bottom: 16px;
}
.card-list {
  display: flex;
  gap: 16px;
  min-width: max-content;
}
.doctor-card {
  border: 2px solid #9b1c7b;
  border-radius: 12px;
  padding: 12px 16px;
  min-width: 240px;
  text-align: center;
  background: #fdfcff;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.doctor-card:hover {
  transform: translateY(-2px);
}
.doctor-detail-card {
  text-align: center;
  margin-bottom: 16px;
}
.doctor-detail-grid {
  margin-bottom: 16px;
}
.verification-form {
  margin-top: 16px;
  padding: 16px;
  background-color: #fafafa;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
}
.form-item {
  margin-bottom: 16px;
}
.form-item label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}
.doctor-detail-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
}
.modal-image {
  width: 100%;
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: contain;
}
body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
  background-color: #f7f9fc;
}
#app-container {
  max-width: 600px;
  margin: 20px auto;
  padding: 24px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  text-align: center;
}
h1 {
  color: #1a237e;
}
p {
  color: #555;
}

/* --- QR Reader --- */
.scanner-wrapper {
  padding: 10px;
}
#reader {
  width: 100%;
  border: 2px dashed #d0d0d0;
  border-radius: 12px;
  margin-top: 16px;
  overflow: hidden;
  position: relative; /* Diperlukan untuk beberapa elemen child */
}

/* --- [BARU] STYLING UNTUK TOMBOL BAWAAN SCANNER --- */
#reader button {
  background-color: #800152 !important; /* Warna primer Ant Design */
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 10px 16px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  margin: 5px !important;
  transition: background-color 0.3s ease !important;
}
#reader button:hover {
  background-color: #fdb752 !important; /* Warna hover Ant Design */
}

/* --- [BARU] STYLING UNTUK DROPDOWN KAMERA --- */
#reader select {
  background-color: #fff !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 8px !important;
  padding: 9px 12px !important;
  font-size: 14px !important;
  cursor: pointer !important;
  margin: 5px !important;
  outline: none; /* Hilangkan outline biru saat fokus */
}
#reader select:focus {
  border-color: #800152 !important;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
}

/* Teks link 'File based scanning' */
#reader a {
  color: #fdb752 !important;
}

/* --- Scan Result Styling --- */
.scan-result {
  width: 100%;
  text-align: left;
}
.result-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
}
.patient-profile {
  text-align: center;
  background: linear-gradient(135deg, #e3f2fd, #e8eaf6);
}
.patient-profile h3 {
  margin: 0 0 4px 0;
  color: #1a237e;
}
.patient-profile .patient-meta {
  color: #5c6bc0;
  margin: 0;
}
.info-section h4 {
  margin-top: 0;
  margin-bottom: 12px;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
  color: #3949ab;
}

/* --- Info Grid & Document Viewer --- */
.info-grid {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px 16px;
}
.info-grid strong {
  color: #444;
}
.document-list details {
  border-bottom: 1px solid #f0f0f0;
  padding: 8px 0;
}
.document-list details:last-child {
  border-bottom: none;
}
.document-list summary {
  cursor: pointer;
  font-weight: 500;
  color: #007bff;
}
.document-list img,
.document-list iframe {
  width: 100%;
  height: auto;
  min-height: 400px;
  border-radius: 8px;
  margin-top: 10px;
  border: 1px solid #ccc;
}

/* --- Action Buttons --- */
.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}
#reader video {
  /* Membalik video secara horizontal untuk efek cermin */
  transform: scaleX(-1);
  -webkit-transform: scaleX(-1); /* Untuk kompatibilitas browser lama */
}
</style>
